/* block */
(function(){
  function hideZeroCart(){
    try{
      document.querySelectorAll('a[href*="/cart"], [class*="cart"], [class*="bag"]').forEach(function(node){
        var w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null, false);
        var n;
        while((n=w.nextNode())){
          if (/\(\s*0\s*\)/.test(n.nodeValue)){
            n.nodeValue = n.nodeValue.replace(/\s*\(\s*0\s*\)\s*/g, '');
          }
        }
      });
      document.querySelectorAll('.cart-count-bubble, .header__cart-count, .cart-icon-bubble, .cart-link__bubble').forEach(function(el){
        var txt = (el.textContent||'').trim();
        if (txt === '0' || txt === '(0)' || txt === ''){ el.style.display = 'none'; }
      });
    }catch(e){}
  }
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', hideZeroCart); }
  else { hideZeroCart(); }
  document.addEventListener('cart:updated', hideZeroCart);
  document.addEventListener('shopify:section:load', hideZeroCart);
  setTimeout(hideZeroCart, 500);
  setTimeout(hideZeroCart, 1500);
  setTimeout(hideZeroCart, 3000);
})();
